import React, { useCallback } from "react";
import { Box, RoutineOccasionStatusCircleRelay, TouchableBox } from "arkh";
import { useFragment, graphql } from "react-relay";
import { WidgetTeamScheduleRoutineListItemContent } from "./WidgetTeamScheduleRoutineListItemContent";
import { WidgetTeamScheduleRoutineIssueIndicator } from "./WidgetTeamScheduleRoutineIssueIndicator";
import { WidgetTeamScheduleRoutineOccasionListItem_item$key } from "./__generated__/WidgetTeamScheduleRoutineOccasionListItem_item.graphql";

export function WidgetTeamScheduleRoutineOccasionListItem(props: {
  onPress?(routineId: string, sequenceNumber: number): void;
  item: WidgetTeamScheduleRoutineOccasionListItem_item$key;
  status: "active" | "soon" | "none";
  freq: "DAILY" | "WEEKLY" | "MONTHLY";
  size: "COMPACT" | "DEFAULT" | "LARGE";
  tint: string;
}) {
  const item = useFragment(
    graphql`
      fragment WidgetTeamScheduleRoutineOccasionListItem_item on RoutineOccasion {
        ...RoutineOccasionStatusCircle_RoutineOccasion
        ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion
        ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion
        totalTaskExecutionCount
        sequenceNumber
        routine {
          id
          ...WidgetTeamScheduleRoutineListItemContent_Routine
        }
      }
    `,
    props.item
  );
  const { onPress } = props;
  const op = useCallback(() => {
    onPress?.(item.routine.id, item.sequenceNumber);
  }, [item.routine.id, item.sequenceNumber, onPress]);
  return (
    <TouchableBox
      onPress={op}
      disabled={!props.onPress}
      style={{
        flex: 1,
        flexDirection: "row",
        justifyContent: "space-between",
        alignContent: "center",
        alignItems: "center",
        height: "100%",
      }}
      spaceRight="medium"
    >
      <WidgetTeamScheduleRoutineListItemContent
        routine={item.routine}
        status={props.status}
        size={props.size}
        routineOccasion={item}
        freq={props.freq}
      />
      {(item.totalTaskExecutionCount ?? 0) > 0 ? (
        <Box>
          <WidgetTeamScheduleRoutineIssueIndicator routineOccasion={item} />
          <RoutineOccasionStatusCircleRelay occasion={item} useDeadlineAt />
        </Box>
      ) : null}
    </TouchableBox>
  );
}
